<template>
  <div>
    <vs-prompt
      title="Add new HQ campaign"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="Add"
      :is-valid="validForm"
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Title</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vx-tooltip
                text="This will be the title of this HQ campaign. It can be changed later."
                position="bottom"
              >
                <vs-input class="inputx w-full" v-model="name" />
              </vx-tooltip>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      name: "",
      prompt: false,
    };
  },
  computed: {
    validForm() {
      return this.name !== "";
    },
  },
  methods: {
    show() {
      this.name = "";
      this.prompt = true;
    },
    async accept() {
      this.$vs.loading();

      var result = await this.$store.dispatch("masterCampaigns/create", { title: this.name });
      this.$router.push({ name: "crm-campaign", params: { id: result } }).catch(() => {});

      this.$vs.notify({
        color: "green",
        title: `HQ campaign created`,
        text: "HQ campaign created",
      });
      this.$vs.loading.close();
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
